import { render, staticRenderFns } from "./modalDeleteTeam.vue?vue&type=template&id=610d85ad&"
import script from "./modalDeleteTeam.vue?vue&type=script&lang=js&"
export * from "./modalDeleteTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports